<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange"></SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showIndex="true"
      :allBtnWidth="'180px'" :getTotal="getTotal" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="car_type" slot-scope="params">
        <span v-if="params.params.car_type == 1">车头</span>
        <span v-if="params.params.car_type == 2">车挂</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'car',
      getListUrl: 'insurancesummarize',
      getOptionUrl: 'options',
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.license,
        },
        {
          label: "车型",
          keyName: "car_type",
          placeholder: "请选择车型",
          type: "select",
          options: [
            { label: '车头', value: 1 },
            { label: '车挂', value: 2 },
          ],
        },
        {
          label: "到期时间",
          keyName: "maturitytime",
          placeholder: "请选择开始结束时间",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { prop: "license", label: "车牌号" },
        { prop: "driver", label: "司机" },
        { prop: "car_type", label: "车型", slot: 'car_type' },
        { prop: "type_name", label: "保险名称" },
        { prop: "maturitytime", label: "到期时间" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ car_id, car_type, license }) => {
            this.$router.push(`/vehicle/insurance2?car_type=${car_type}&id=${car_id}&license=${license}`);
          },
        },
      ],
    };
  },
  methods: {
    setOptions({ data: { reimburse_user_list } }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'reimburse_user_name' && reimburse_user_list && reimburse_user_list.length) {
          c.options = reimburse_user_list.map(v => {
            return {
              label: v.nickname,
              value: v.nickname,
            }
          })
          // console.log(c.options)
        }
      })
      this.$forceUpdate()
    },
  },
  mounted() {
    // this.getOptions()
  },
};
</script>

<style lang="less" scoped></style>
